<template>
  <div id="app" class="min-h-screen bg-gray-50">

    <!-- 根据认证状态选择布局 -->
    <IframeLayout v-if="authStore.isAuthenticated && !['Home', 'Login', 'Register'].includes($route.name)" />
    <router-view v-else />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import IframeLayout from '@/components/Layout/IframeLayout.vue'

const authStore = useAuthStore()

// 应用初始化
onMounted(async () => {
  // 初始化认证状态
  await authStore.initAuth()
})
</script>

<style>
/* 全局样式已在 style.css 中定义 */
</style>
